import { render, staticRenderFns } from "./componentsPlayground.vue?vue&type=template&id=4c5549e3&"
import script from "./componentsPlayground.vue?vue&type=script&lang=js&"
export * from "./componentsPlayground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports